import React, { useState, useEffect } from 'react';

// material-ui
import { CssBaseline, Divider, Grid, Stack, FormControl, InputAdornment, OutlinedInput, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Link } from '@mui/material';
import { Search } from '@mui/icons-material';

//components
import AlertInfo from '../../dataObjects/AlertInfo';
import AlertInfoDialog from '../../components/elements/AlertInfoDialog';
import TopBar from '../../components/nav/TopBar';
import SimpleFiler from './dataObjects/SimpleFiler';
import AuditorList from '../../data/AuditorList'
import AuditorsDropdown from '../../components/reference/AuditorsDropdown';

//const data
const AUDITORS = AuditorList;

const SignInTrackerApp = (): JSX.Element => {

    //set up browser title
    const pageTitle = 'Extranet - R7 Sign In Tracker';
    document.title = pageTitle;

    const applicationName = 'R7 Email Sign In Tracker';

    //set up state for the app
    const [auditorId, setAuditorId] = useState(0);
    const [showAllFilers, setShowAllFilers] = useState(false);
    const [filers, setFilers] = useState<SimpleFiler[]>();
    const [allFilers, setAllFilers] = useState<SimpleFiler[]>();

    //payload
    useEffect(() => {
        getOutstandingFilers();
    }, [auditorId]);


    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    const updateSearchInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        let searchPhrase = event.target.value;

        setTimeout(() => {
            if (!searchPhrase) {
                setFilers(allFilers);
            }
            else {
                let filteredRecords = filers?.filter(
                    filer => filer.CandidateFullName.toLowerCase().includes(searchPhrase.toLowerCase())
                        || filer.TreasurerFullName.toLowerCase().includes(searchPhrase.toLowerCase())
                        || filer.CpfId.toString().includes(searchPhrase.toLowerCase())
                );
                setFilers(filteredRecords);
            }
        }, 800)
    }

    const getOutstandingFilers = async () => {
        await fetch(`/IT/GetCommitteesWithoutEmailLogins?auditorId=${auditorId}&showAllFilers=${showAllFilers}`)
            .then(result => result.json())
            .then(result => {
                setAuditorId(result.auditorId)
                setFilers(result.results);
                setAllFilers(result.results);
                }
            )
    }

    const updateAuditorId = (auditorId: number) => {
        setAuditorId(auditorId);
        setShowAllFilers(auditorId === 0);
    }

    return (
        <div>
            <Grid container sx={{ display: 'flex' }}>
                <CssBaseline />
                <TopBar applicationName={applicationName}></TopBar>
            </Grid>
            <Grid item xs={12} marginBottom={1}>
                <Divider />
            </Grid>
            <Grid container sx={{ display: 'flex', justifyContent: 'center', marginTop: '30px', marginBottom: '15px' }} >
                <Grid item xs={10}>
                    <Stack marginBottom={3}>
                        <Typography variant="h6" fontWeight={400} color="error">Outstanding filers without R7 email sign-ins: {filers?.length} filers</Typography>
                    </Stack>
                    <Stack direction="row" spacing={2} >
                        <AuditorsDropdown auditorId={auditorId} auditors={AUDITORS} updateAuditorId={updateAuditorId}></AuditorsDropdown>
                        <FormControl sx={{ minWidth: 200, marginTop: "5px !important" }} variant="outlined" size="small">
                            <OutlinedInput
                                aria-label='Search Filer...'
                                title='Search Filer'
                                placeholder={"search name or cpf id..."}
                                onChange={updateSearchInput}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </Stack>
                </Grid>
            </Grid>
            {
                filers && filers.length > 0 &&
                <Grid container marginTop={5} display={'flex'} justifyContent={'flex-start'} >
                    <Grid item xs={1}></Grid>
                    <Grid item xs={9}>
                            <TableContainer>
                                <Table stickyHeader size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><Typography variant='body1' fontWeight={550}>CPF ID</Typography></TableCell>
                                            <TableCell><Typography variant='body1' fontWeight={550}>Account</Typography></TableCell>
                                            <TableCell><Typography variant='body1' fontWeight={550}>Committee</Typography></TableCell>
                                            <TableCell><Typography variant='body1' fontWeight={550}>Candidate</Typography></TableCell>
                                            <TableCell><Typography variant='body1' fontWeight={550}>Treasurer</Typography></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filers.map((filer: SimpleFiler) =>
                                            <TableRow key={filer.CpfId}>
                                                <TableCell width="10%">
                                                    <Typography variant="body2" component={Link} href={`/Filers?q=${filer.CpfId}`} target="_blank" underline="hover">{filer.CpfId}</Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body2">{filer.AccountTypeCode}</Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body2">{filer.CommitteeName}</Typography>
                                                </TableCell>
                                                <TableCell>
                                                    {
                                                        (filer.AccountTypeCode === 'U' || filer.AccountTypeCode === 'D' || filer.AccountTypeCode === 'S') &&
                                                        <Typography variant="body2">{filer.CandidateFullName}</Typography>
                                                    }
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body2">{filer.TreasurerFullName}</Typography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                    </Grid>
                </Grid>
            }
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </div>
    );
};

export default SignInTrackerApp;